import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const TITLE_BLUE = "#175cd3";
const SIDEBAR_BG = "#f7f9fb";
const SIDEBAR_BORDER = "#e6ebf1";

const videoData = [
  { id: 1,  title: "1. Introducción general a la Ley Fintech en México", embed: "https://drive.google.com/file/d/1WYra-s6FMgtI5GqSEMcJDLjipLcZWvWV/preview" },
  { id: 2,  title: "2. Casos de éxito Fintech en LATAM y México",         embed: "https://drive.google.com/file/d/1FTPDzGYbNqtn8t3jAERoePfZ09s5g_mD/preview" },
  { id: 3,  title: "3. Estructura del sistema financiero mexicano",         embed: "https://drive.google.com/file/d/1nrVZMSGVHq11SHrfMhaJ-UauNheGry4F/preview" },
  { id: 4,  title: "4. Tecnología y la Cuarta Revolución Industrial",       embed: "https://drive.google.com/file/d/1we0AN0CB0bKL9CtHDkWiMdh5WntkWRtb/preview" },
  { id: 5,  title: "5. Avances tecnológicos y empresas innovadoras",        embed: "https://drive.google.com/file/d/1jXHYgWEfiFIJXw97lREFFUT_lwiqlyHS/preview" },
  { id: 6,  title: "6. Innovación Financiera",                              embed: "https://drive.google.com/file/d/1VPpFeZ8cHPVXN5Yztko5CzZXCqDSlyWl/preview" },
  { id: 7,  title: "7. Crowdfunding: La Fuerza de la Colaboración Financiera", embed: "https://drive.google.com/file/d/1B99NTx6YFCT8TBSqVWJ0ZXqCQFGtNA0W/preview" },
  { id: 8,  title: "8. Wallets Digitales",                                  embed: "https://drive.google.com/file/d/15WMkFVAk6bBZbuZInMzZPOdbZG08BO3k/preview" },
  { id: 9,  title: "9. Wallets Digitales y la Nueva Era Financiera",        embed: "https://drive.google.com/file/d/1F95c6iYywIiAROEPvJ8x9r2t_FG-R33W/preview" },
  { id: 10, title: "10. Criptomonedas",                                     embed: "https://drive.google.com/file/d/1eGsOtoHrkvjnJ_Dd1KoZIyOCQRfwBvW4/preview" },
];

const VideoViewer = () => {
  const { videoId } = useParams();
  const navigate = useNavigate();

  const [selected, setSelected] = useState(() => {
    return videoData.find((v) => v.id === parseInt(videoId)) || videoData[0];
  });

  useEffect(() => {
    const found = videoData.find((v) => v.id === parseInt(videoId));
    if (found) setSelected(found);
  }, [videoId]);

  const handleSelect = (video) => navigate(`/course/ley-fintech/${video.id}`);

  return (
    <div className="vv-serif-root vv-wrap">
      {/* Tipografía serif y estilos de sidebar alineados con tu LessonSidebar */}
      <style>{`
        .vv-serif-root, .vv-serif-root * {
          font-family: Georgia, "Times New Roman", Times, serif;
          letter-spacing: .01em;
        }
        .vv-wrap {
          display: flex;
          height: 100dvh;
          background: #fff;
        }

        /* Sidebar estilo LessonSidebar */
        .vv-sidebar {
          width: 280px;
          background: ${SIDEBAR_BG};
          border-right: 1px solid ${SIDEBAR_BORDER};
          position: sticky;
          top: 0;
          height: 100dvh;
          overflow: auto;
        }
        .vv-title {
          background: ${TITLE_BLUE};
          color: #fff;
          font-weight: 800;
          font-size: 15px;
          padding: 14px 12px;
          margin: 0 0 12px 0;
          border-radius: 0;
          text-align: left;
        }
        .vv-subtitle {
          color: #102a43;
          font-weight: 700;
          font-size: 13px;
          padding: 0 12px 8px 12px;
        }

        .vv-items {
          list-style: none;
          margin: 0;
          padding: 0 6px 12px 6px;
        }
        .vv-itemBtn {
          all: unset;
          display: grid;
          grid-template-columns: 12px 1fr auto;
          align-items: center;
          gap: 10px;
          width: 100%;
          padding: 8px 10px 8px 6px;
          margin: 2px 4px;
          color: #243b53;
          cursor: pointer;
          border-radius: 0;
          text-align: left;
        }
        .vv-itemBtn:hover { background: #ffffff; }
        .vv-itemLabel {
          font-size: 13px;
          line-height: 1.2;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .vv-itemActive .vv-itemLabel { color: ${TITLE_BLUE}; font-weight: 800; }
        .vv-check {
          font-size: 12px;
          font-weight: 900;
          color: ${TITLE_BLUE};
          padding: 0 2px;
        }

        /* Viewer */
        .vv-viewer {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
        }
        .vv-frameWrap {
          width: 95%;
          max-width: 960px;
          margin: 0 auto;
        }
        .vv-iframe {
          width: 100%;
          height: 480px;
          border: 0;
        }

        @media (max-width: 768px) {
          .vv-sidebar { width: 240px; }
          .vv-iframe { height: 360px; }
        }
      `}</style>

      {/* Sidebar */}
      <aside className="vv-sidebar" aria-label="Navegación de la Semana 1">
        <h1 className="vv-title">LEY FINTECH</h1>
        <div className="vv-subtitle">Semana Uno</div>

        <ul className="vv-items">
          {videoData.map((video) => {
            const active = selected.id === video.id;
            return (
              <li key={video.id}>
                <button
                  className={`vv-itemBtn ${active ? "vv-itemActive" : ""}`}
                  onClick={() => handleSelect(video)}
                  aria-current={active ? "page" : undefined}
                >
                  <span aria-hidden="true" />
                  <span className="vv-itemLabel">{video.title}</span>
                  {active && <span className="vv-check">✓</span>}
                </button>
              </li>
            );
          })}
        </ul>
      </aside>

      {/* Video Viewer */}
      <main className="vv-viewer">
        <div className="vv-frameWrap">
          <iframe
            key={selected.id}
            src={selected.embed}
            className="vv-iframe"
            allow="autoplay"
            allowFullScreen
            title={selected.title}
          />
        </div>
      </main>
    </div>
  );
};

export default VideoViewer;
